import React from "react";
import CoPilotForm from "./CoPilotForm";

const AddCoPilotPage = () => {
  return (
    <div id="content">
      <div id="content-title">Add Copilot Question</div>

      <div className="content-bubble">
        <CoPilotForm />
      </div>
    </div>
  );
};

export default AddCoPilotPage;
